import { RuleId } from '@wix/a11y-rules';
import { useCallback } from 'react';
import { useBiLogger } from '../../../../hooks/use-bi-logger';
export const useInaccessibleLayoutAnalytics = _ref => {
  let {
    elements,
    failedElements
  } = _ref;
  const biLogger = useBiLogger();
  const createLayoutTypeMap = useCallback((sessionElements, failed) => {
    const layoutTypeMap = new Map();
    failed.forEach(element => {
      const layoutType = element.type || 'unknown';
      if (!layoutTypeMap.has(layoutType)) {
        layoutTypeMap.set(layoutType, {
          element_count: 0,
          failed_element_count: 0
        });
      }
      const currentData = layoutTypeMap.get(layoutType);
      layoutTypeMap.set(layoutType, {
        element_count: currentData.element_count + 1,
        failed_element_count: currentData.failed_element_count + 1
      });
    });
    sessionElements.forEach(element => {
      const layoutType = element.type || 'unknown';
      const isFailed = failed.some(f => f.id === element.id);
      if (!isFailed) {
        if (!layoutTypeMap.has(layoutType)) {
          layoutTypeMap.set(layoutType, {
            element_count: 0,
            failed_element_count: 0
          });
        }
        const currentData = layoutTypeMap.get(layoutType);
        layoutTypeMap.set(layoutType, {
          element_count: currentData.element_count + 1,
          failed_element_count: currentData.failed_element_count
        });
      }
    });
    return layoutTypeMap;
  }, []);
  const createGenericLayoutsData = useCallback(layoutTypeMap => {
    return Array.from(layoutTypeMap.entries()).map(_ref2 => {
      let [layoutType, counts] = _ref2;
      return {
        comptype: layoutType,
        element_count: counts.element_count,
        failed_element_count: counts.failed_element_count
      };
    });
  }, []);
  const manualTaskDataEvent = useCallback(() => {
    const layoutTypeMap = createLayoutTypeMap(elements, failedElements);
    const genericLayoutsData = createGenericLayoutsData(layoutTypeMap);
    const elementCount = Math.max(elements.length, failedElements.length);
    biLogger.manualTaskData({
      elementCount,
      failedElementCount: failedElements.length,
      genericElementsData: JSON.stringify(genericLayoutsData),
      manualElementCount: elementCount,
      manualFailedElementCount: failedElements.length,
      taskName: RuleId.INACCESSIBLE_LAYOUT
    });
  }, [biLogger, createLayoutTypeMap, createGenericLayoutsData, elements, failedElements]);
  return {
    manualTaskDataEvent
  };
};
//# sourceMappingURL=use-inaccessible-layout-analytics.js.map